import React from "react";

export default ({ record }) => <span>Borne {record ? record.title : ""}</span>;



// WEBPACK FOOTER //
// ./src/components/kioskTitle.js